<template>
    <!-- <div class="sidebar-overlay" :class="{ hidden: !localVisible }" @click="handleToggleSidebar()"></div> -->
  <aside class="sidebar" :class="{ hidden: !localVisible }">
    <div class="logo"></div>
    <div class="close" v-on:click="handleToggleSidebar()"></div>
    <ul class="links">
      <li v-for="(r, index) in routes" :key="index" @click="hideSidebar()">
        <router-link :to="r.path" :class="{ active: $route.path === r.path }">{{ localize(r.name) }}</router-link>
      </li>
      <li><router-link to="/logout">{{ localize("mm-logout") }}</router-link></li>
    </ul>
  </aside>
</template>

<script setup>
import appRoutes from "@/hooks/useRoutes";
import { localize } from "@/locale/i18n"
import { watch, ref } from 'vue';

const emit = defineEmits(['toggle-sidebar'])
const localVisible = ref(window.innerWidth > 1024);
const props = defineProps({
  isOpen: {
    type: Boolean,
    default: true,
  },
});

watch(() => props.isOpen, () => {
  localVisible.value = !localVisible.value;
});

function handleToggleSidebar() {
  emit("toggle-sidebar");
}

function hideSidebar() {
  if (window.innerWidth > 1024) {
    return;
  }
  emit("toggle-sidebar");
}

const routes = appRoutes.getCatRoutes('menu')
</script>

<style lang="scss" scoped>
.sidebar-overlay {
  display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 39;
  }
  
.sidebar {
  position: static;
  background-color: var(--theme-color-background-a10);
  width: 265px;
  max-width: 265px;
  min-height: 100%;
  flex-grow: 10;
  flex-shrink: 0;
  z-index: 40;
  user-select: none;

  &.hidden {
    display: none;
  }

  ul {
    list-style: none;
    padding: 0;

    li {
      padding: 0;
    }
  }

  .logo {
    height: 100px;
    margin: 0 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 100%;
    color: var(--theme-color-text-a10);
    margin-bottom: 12px;
    background-image: url("@/assets/logo-v1.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;

    .p189 {
      font-size: 36px;
      line-height: 100%;
      font-weight: bolder;
      font-family: "InterMedium";
      color: var(--theme-color-accent-a0);
    }

    .pCorporate {
      font-size: 26px;
      font-family: "InterMedium";
      font-style: italic;
      color: var(--theme-color-accent-a0);
      margin-left: 8px;
    }
  }

  .close {
    display: none;
    position: absolute;
    top: 24px;
    right: 24px;
    cursor: pointer;
    background-color: transparent;
    background-image: url("@/assets/close-sb-icon.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
  }

  .links {
    padding: 16px 0;
    border-top: 1px solid var(--theme-color-text-a50);
  }

  a,
  .linkus {
    font-family: "InterRegular";
    font-size: 16px;
    line-height: 100%;
    display: block;
    color: var(--theme-color-text-a10);
    padding: 14px 40px;
    margin-bottom: 6px;
    cursor: pointer;

    &:hover {
      color: var(--theme-color-text-a10);
      background-color: var(--theme-color-accent-b10);
    }

    &.router-link-exact-active {
      color: var(--theme-color-text-a10);
      background-color: var(--theme-color-accent-b00);
    }
  }
}

@media (max-width: 1024px) {
  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    box-shadow: 0 0 8px #aaaaaa;
    z-index: 40;
    padding-top: 52px;

    .links {
      border-top: none;
    }

    .logo {
      display: none;
    }

    .close {
      display: block;
    }
  }
}
</style>